// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGetCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomainsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      hostType: string,
      domainType: string,
      hostParentId: string,
      hostId: string,
      hostname: string,
      channel: string,
    })
  ),
});
